exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider_container_o2aIb {\n    margin: 8px;\n    height: 22px;\n    width: 150px;\n    position: relative;\n    outline: none;\n    border-radius: 11px;\n    margin-bottom: 16px;\n}\n\n.slider_last_10jvO {\n    margin-bottom: 4px;\n}\n\n.slider_handle_3f0xk {\n    left: 100px;\n    width: 26px;\n    height: 26px;\n    margin-top: -2px;\n    position: absolute;\n    background-color: white;\n    border-radius: 100%;\n    -webkit-box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);\n            box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.15);\n    -ms-touch-action: none;\n        touch-action: none;\n}\n", ""]);

// exports
exports.locals = {
	"container": "slider_container_o2aIb",
	"last": "slider_last_10jvO",
	"handle": "slider_handle_3f0xk"
};